import {Box, Grid, Dialog} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {useState} from 'react';

/**
 * Renders an image that can be clickable and when clicked displays the same iamge but in a modal
 *
 * @param {Object} props - Component props
 * @param {string} props.src - source of the image
 * @param {any} props.width - material ui height prop for the clickable image
 * @param {any} props.height - material ui height prop for the clickable image
 *
 * @returns {React.Component}
 */
export const ImagePreview = ({src, width, height}) => {
  const [opened, setOpened] = useState(false);

  const onClose = () => setOpened(false);

  return (
    <Box
      sx={{
        height: height || '100%',
      }}
    >
      <Box
        component="img"
        src={src}
        sx={{
          width: width || '100%',
          height: '100%',
          objectFit: 'cover',
          cursor: 'pointer',
        }}
        onClick={() => setOpened(true)}
      ></Box>
      <Dialog open={opened} onClose={onClose} maxWidth="none">
        <Grid
          container
          sx={{
            px: 1,
            py: 2,
            flexDirection: 'column',
          }}
        >
          <Grid
            item
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              pb: 1,
            }}
          >
            <CloseIcon
              onClick={onClose}
              fontSize="large"
              sx={{
                cursor: 'pointer',
              }}
            />
          </Grid>
          <Grid
            item
            sx={{
              display: 'flex',
              justifyContent: 'center',
              px: 1,
            }}
          >
            <img
              src={src}
              style={{
                display: 'block',
                borderRadius: 5,
                width: '95%',
                height: '50vh',
                objectFit: 'contain',
              }}
            />
          </Grid>
        </Grid>
      </Dialog>
    </Box>
  );
};
